// The disable-when-offline seam.
//
// `lead.update` and `lead.stageChange` require connectivity — their controls
// (Edit, the quick-stage chips, archive/restore) are DISABLED offline, per
// docs/plan.md. Later waves read `useIsOffline()` to disable those controls and
// show the "needs a connection" explanation, while lead CAPTURE stays enabled
// (it queues to the outbox).
//
// The authority is the session store's `connectivity`, which is derived only
// from what `fetch` actually did (never `navigator.onLine`) — so a captive
// hall wifi that routes nowhere reads as offline here, correctly.
import { useSessionStore } from '@/lib/auth/session';

/** True only once a real fetch has failed to reach the server. 'unknown' is treated as online. */
export function useIsOffline(): boolean {
  return useSessionStore(state => state.connectivity === 'offline');
}

/** Convenience inverse for enabling controls. */
export function useIsOnline(): boolean {
  return useSessionStore(state => state.connectivity !== 'offline');
}
